import withAuth from '../utils/hoc/withAuth'
import campaignImg from "../assets/images/home/campaign.png"
import smartLinksImg from "../assets/images/home/smart-links.png"
import shareEarnImg from "../assets/images/home/share-earn.png"
import referEarnImg from "../assets/images/home/refer-earn.png"
import { Link } from 'react-router-dom'
import HomepageTicker from '../components/Ticker/HomepageTicker'

const Home: React.FC = () => {
    return (
        <div className='home'>
             <div className="home-ticker-wrap px-0">
                <HomepageTicker />
            </div>
            <div className="intro pb-2">
                <span>ARE YOU READY TO </span>
                <h1>Influence</h1>
            </div>
            <div className="home-menu row g-3">
                <div className="col-6">
                    <Link to="/campaign">
                        <div className="home-menu-item">
                            <img className='home-menu-item-img' src={campaignImg} alt="find collabs" />
                            <span>Find Collabs</span>
                        </div>
                    </Link>
                </div>
                <div className="col-6">
                    <Link to="/smart-links">
                        <div className="home-menu-item">
                            <img className='home-menu-item-img' src={smartLinksImg} alt="smart links" />
                            <span>Smart Links</span>
                        </div>
                    </Link>
                </div>
                <div className="col-6">
                    <Link to="/conversion">
                        <div className="home-menu-item">
                            <img className='home-menu-item-img' src={shareEarnImg} alt="share earn" />
                            <span>Share & Earn</span>
                        </div>
                    </Link>
                </div>
                <div className="col-6">
                    <Link to="/referral">
                        <div className="home-menu-item">
                            <img className='home-menu-item-img' src={referEarnImg} alt="refer earn" />
                            <span>Refer & Earn</span>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default withAuth(Home)